import React, { RefObject, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
type StickyCTAProps = {
  targetRef: RefObject<HTMLElement>;
};
export function StickyCTA({
  targetRef
}: StickyCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = targetRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [targetRef]);
  return <AnimatePresence data-id="element-362" data-mp="1hfn33up3k4qh">
      {visible && <motion.div initial={{
      y: '110%'
    }} animate={{
      y: 0
    }} exit={{
      y: '110%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink/95 px-3 pt-3 backdrop-blur-md" style={{
      paddingBottom: 'calc(env(safe-area-inset-bottom) + 12px)'
    }} data-id="element-363" data-mp="1li09mlbo46ob">
          <div className="mx-auto max-w-md" data-id="element-364" data-mp="3f9eyzbzw5ne4">
            <CTAButton compact shake label="Get the Torque Control Blueprint" price="$27" data-id="element-365" data-mp="3adg7vgn6hra0" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}